
export const useStyles = theme => ({
  registrationHeaderWrapper: {
    padding: '12px',
    //background: 'var(--header_bg)',
    justifyContent:'center',
    '&.no-logo':{
      "& h1": { visibility:'hidden' }
    }
  },
  logoContainer: {
    width:'33.3%',
    padding:'0,15px',
    "& h1": {
      margin: 0,
      lineHeight: 0,
     '& a':{ textDecoration: 'none' },
      "& img": { width: '80%' },
    },
  },
  contentContainer:{
    //minHeight:'calc(100vh - 10px)',
    backgroundColor:'var(--header_bg)',
    backgroundImage: 'url(/static/images/lr-bg-login.jpg)',
    backgroundRepeat: 'repeat-x',
    backgroundSize: 'auto 100%',
    bottom: 20,
    position: 'absolute',
    top: 0,
    width: '100%',
    color:'var(--header_color)'
  }
});
  